import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import AuthService from './services/auth.service';
import Login from './components/Login';
import Home from './components/Home';
// import Private from './components/Private';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [, setCurrentUser] = useState(undefined);

  useEffect(() => {
    const user = AuthService.getCurrentUser();

    if (user) {
      setCurrentUser(user);
    }
  }, []);

  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </div>
  );
}

export default App;
